import { render } from "./About.vue?vue&type=template&id=812e9e72"
const script = {}
script.render = render

export default script